import type { SVGProps } from 'react';
const SvgKnowledge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 11 13" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.333 10.646A1.354 1.354 0 0 1 2.687 9.29H10"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.687 1.167H10V12H2.687a1.354 1.354 0 0 1-1.354-1.354V2.52a1.354 1.354 0 0 1 1.354-1.354"
    />
  </svg>
);
export default SvgKnowledge;
